import { render, staticRenderFns } from "./UserSsids.vue?vue&type=template&id=e552f6ee&"
import script from "./UserSsids.vue?vue&type=script&lang=js&"
export * from "./UserSsids.vue?vue&type=script&lang=js&"
import style0 from "./UserSsids.vue?vue&type=style&index=0&id=e552f6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports